<template>
    <view-analytics-base
        :currentRoute="currentRoute"
        :currentTitle="'Менеджеры'"
        :rowLabel="'Менеджер'"
        :subColumnLabel="''"
        :rowTitleLimitIndex="0"
    />
</template>

<script>
/** пока что вывожу направление через клиентов, позже компоненты могут стать разными */
import schemeApi from '../../schemes/schemeApi';
import ViewAnalyticsBase from "@/views/ViewAnalytics/ViewAnalyticsBase";
let {routeAnalyticsManagers} = schemeApi;
export default {
    name: 'ViewAnalyticsManagers',
    components: {
      ViewAnalyticsBase
    },
    /**
     * данные компонента
     * @property {string} currentRoute - текущий маршрут
     */
    data: () => ({
        currentRoute: routeAnalyticsManagers
    }),
    
}
</script>